import { useMutation } from "@tanstack/react-query";
import { UpdateClientOperationRequest } from "@/Stub/V1";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";
import { ClientsApiClient } from "@/Service/Api/V1/ApiClients/ClientsApiClient";

export const useUpdateClient = () => useMutation({
    mutationFn: async (data: UpdateClientOperationRequest) => {
        try {
            return await ClientsApiClient.updateClient(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});